import { CAMPAIGN_BAR_TONES } from '../model/campaign-detail'
import type { CampaignBarTone } from '../model/campaign-detail'

const BAR_FILL: Record<CampaignBarTone, string> = {
  [CAMPAIGN_BAR_TONES.email]: 'bg-campaign-bar-email',
  [CAMPAIGN_BAR_TONES.sms]: 'bg-campaign-bar-sms',
  [CAMPAIGN_BAR_TONES.task]: 'bg-campaign-bar-task',
  [CAMPAIGN_BAR_TONES.idle]: 'bg-campaign-bar-idle',
}

interface CampaignReachBarProps {
  /** 0–1 share of the track. */
  reach: number
  tone: CampaignBarTone
  /** Read out to assistive tech, since the width alone carries the meaning. */
  label: string
}

/** How many people a step reached, drawn as width against a shared track. */
export function CampaignReachBar({
  reach,
  tone,
  label,
}: CampaignReachBarProps) {
  return (
    <div
      role="img"
      aria-label={label}
      className="h-4.5 w-full overflow-hidden rounded bg-campaign-bar-track"
    >
      <div
        className={`h-full ${BAR_FILL[tone]}`}
        style={{ width: `${Math.round(reach * 100)}%` }}
      />
    </div>
  )
}
